// Intercalado de las plantillas de varias categorías en UNA sola lista, para la
// grilla "sin filtro" de las pantallas de plantillas.
//
// El problema que resuelve: la grilla es un masonry de `columns` CSS, que llena
// la columna 1 con el primer cuarto de la lista, la columna 2 con el segundo, y
// así. Con la lista armada categoría por categoría —que es el orden natural del
// fetch— eso deja cada columna con una sola categoría: dos columnas de fotos con
// modelo y dos de producto sobre fondo limpio. Se ve como dos catálogos pegados,
// no como una galería.
//
// Lo que se quiere es ver de a una imagen de cada categoría por vez.

/**
 * Mezcla los grupos en una sola lista tomando de a uno de cada uno, y REPARTIENDO
 * a los grupos chicos a lo largo de toda la lista.
 *
 * No es un round-robin puro (uno de cada uno hasta que se acaben): con grupos de
 * tamaños distintos —hoy 15 / 12 / 6 / 4— el round-robin agota a los chicos en el
 * primer tramo y deja una cola larga de la categoría más grande, o sea el mismo
 * apelmazamiento de antes pero al final. Acá cada plantilla se ubica por su
 * posición RELATIVA dentro de su categoría —la 3ª de 6 va al medio, igual que la
 * 8ª de 15—, así que las cuatro categorías quedan espaciadas de punta a punta y
 * cualquier tramo de la grilla tiene de todo.
 *
 * El orden DENTRO de cada grupo se respeta siempre (es la curaduría de la
 * categoría), y los empates se resuelven por el orden en que vienen los grupos.
 */
export function intercalarProporcional<T>(
  grupos: ReadonlyArray<readonly T[]>,
): T[] {
  const conPosicion: { item: T; pos: number; grupo: number; indice: number }[] =
    [];
  grupos.forEach((grupo, iGrupo) => {
    const n = grupo.length;
    grupo.forEach((item, i) => {
      // El +0.5 centra a cada item en su "franja": un grupo de 1 cae al medio
      // (0.5) y no al principio, que es donde lo pondría `i / n`.
      conPosicion.push({ item, pos: (i + 0.5) / n, grupo: iGrupo, indice: i });
    });
  });
  conPosicion.sort(
    (a, b) => a.pos - b.pos || a.grupo - b.grupo || a.indice - b.indice,
  );
  return conPosicion.map((x) => x.item);
}
